/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon20Solid = forwardRef('ArrowDUturnUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.043.434a1.25 1.25 0 0 0-1.586 1.933l2.297 1.883H9a7.25 7.25 0 1 0 0 14.5h4.5a1.25 1.25 0 1 0 0-2.5H9a4.75 4.75 0 1 1 0-9.5h4.754l-2.297 1.883a1.25 1.25 0 0 0 1.586 1.934l3.82-3.134a2.5 2.5 0 0 0 0-3.866L13.044.434Z" })));
});
